import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import config from "../../../content/meta/config";

class Seo extends React.Component {
  render() {
    const { data, pageType } = this.props;
    // console.log(this.props)
    const title = data.title
    const description = data.description
    const image = data.image
    const url = data.url
    const keywords = data.keywords
    const datePublished = data.datePublished
    const dateModified = data.dateUpdated//Note this special - rename!! 

    const r = require('../../../content/resume-json/resume-data')
    let schemaOrgJSONLD = [];
    if (pageType === 'post') {/////POST
      schemaOrgJSONLD = [
        {
          '@context': 'http://schema.org',
          '@type': 'Blog',
          url,
          name: title,
          image: {
            '@type': 'ImageObject',
            url: image,
          },
          author: {
            '@type': 'Person',
            name: config.authorName,
          },
        }, ,
        {
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@id': url,
                name: title,
                image,
              },
            },
          ],
        },
        {
          '@context': 'http://schema.org',
          '@type': 'BlogPosting',
          url,
          name: title,
          alternateName: config.title,
          headline: title,
          image: {
            '@type': 'ImageObject',
            url: image,
          },
          description,
          author: {
            '@type': 'Person',
            name: config.authorName,
          },
          publisher: {
            '@type': 'Organization',
            url: config.siteUrl,
            logo: {
              "@type": "ImageObject",
              "url": config.siteUrl + '/' + config.siteLogo,
            },
            name: config.authorName,
          },
          mainEntityOfPage: {
            '@type': 'WebSite',
            '@id': config.url,
          },
          datePublished,
          dateModified,
        },
      ]
    } else if (pageType === 'resume' || pageType === 'contact') {/////RESUME or Contact
      schemaOrgJSONLD = [
        {
          '@context': 'http://schema.org',
          '@type': 'Person',
          url,
          name: config.authorName,
          alternateName: config.title,
          jobTitle: config.jobTitle,
          sameAs: [
            r['github']['url'],
            r['linkedin']['url'],
            r['twitter']['url']
          ],
          "gender": "male",
          //"birthDate": "1996-01-19",
          "image": config.siteUrl + '/' + config.siteImage,
        },
        {
          '@context': 'http://schema.org',
          '@type': 'Blog',
          url,
          name: title,
          image: {
            '@type': 'ImageObject',
            url: image,
          },
          author: {
            '@type': 'Person',
            name: config.authorName,
          },
        },
      ]

    } else if (pageType === 'tagshow' || pageType === 'taglist' || pageType === 'listing') {//ALL listings
      schemaOrgJSONLD = [
        {
          '@context': 'http://schema.org',
          '@type': 'Blog',
          url,
          name: title,
          image: {
            '@type': 'ImageObject',
            url: image,
          },
          author: {
            '@type': 'Person',
            name: config.authorName,
          },
        }, {
          '@context': 'http://schema.org',
          '@type': 'Person',
          url,
          name: config.authorName,
          alternateName: config.title,
          jobTitle: config.jobTitle,
          sameAs: [
            r['github']['url'],
            r['linkedin']['url'],
            r['twitter']['url']
          ],
          "gender": "male",
          //"birthDate": "1996-01-19",
          "image": config.siteUrl + '/' + config.siteImage,
        },
      ]

    }

    return (
      <Helmet
        htmlAttributes={{
          lang: config.siteLanguage,
          prefix: "og: http://ogp.me/ns#"
        }}
      >
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        {(() => {
          // if (pageType === 'post') { // work for all cases now.
          {/* Schema.org tags */ }
          return (<script type="application/ld+json">
            {JSON.stringify(schemaOrgJSONLD)}
          </script>)
          //}
        })()}
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:type" content="website" />
        {/* <meta property="fb:app_id" content={facebook.appId} /> */}

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:creator"
          content={config.authorTwitterAccount ? config.authorTwitterAccount : ""}
        />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
      </Helmet>
    );
  }
};

Seo.propTypes = {
  data: PropTypes.object.isRequired,
  //  facebook: PropTypes.object.isRequired,
  pageType: PropTypes.string.isRequired,
};

export default Seo;



// WEBPACK FOOTER //
// ./src/components/Seo/Seo.js